/**
 * @generated SignedSource<<748ea5e438a6ec94bc8436635f4fdb89>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MoreActionsMenu_MeetingHeader_viewer$data = {
  readonly account: {
    readonly allowAiFeatures: boolean;
  };
  readonly user: {
    readonly isGuest: boolean;
  };
  readonly " $fragmentSpreads": FragmentRefs<"DeleteMeeting_viewer" | "ExportMenuItem_viewer" | "LockNote_viewer" | "MergeSeries_viewer" | "SaveAsTemplate_viewer" | "ShareSeries_viewer" | "UploadMenuItem_viewer" | "VersionHistory_viewer">;
  readonly " $fragmentType": "MoreActionsMenu_MeetingHeader_viewer";
};
export type MoreActionsMenu_MeetingHeader_viewer$key = {
  readonly " $data"?: MoreActionsMenu_MeetingHeader_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"MoreActionsMenu_MeetingHeader_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MoreActionsMenu_MeetingHeader_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Account",
      "kind": "LinkedField",
      "name": "account",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowAiFeatures",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isGuest",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SaveAsTemplate_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MergeSeries_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ExportMenuItem_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "VersionHistory_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "UploadMenuItem_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "LockNote_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DeleteMeeting_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ShareSeries_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "1dd02aa9b48c309b73a3fb8fd90c6060";

export default node;
